/* Click-only instrumentation. No page views, cart or purchase events. */
(() => {
  if (window.__archvFeatureTracking || window.Shopify?.designMode) return;
  window.__archvFeatureTracking = true;
  const query = new URLSearchParams(location.search);
  if (query.has('preview_theme_id') && !query.has('webPixelDebug')) return;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  if (!window.Shopify?.customerPrivacy) {
    window.Shopify?.loadFeatures?.([{name:'consent-tracking-api', version:'0.1'}], () => {});
  }
  document.addEventListener('visitorConsentCollected', () => {
    try { window.Shopify?.analytics?.publish('archv_tracking_consent', {allowed: allowed()}); } catch (_) {}
  });
  document.addEventListener('click', (event) => {
    if (!event.isTrusted || event.button !== 0 || !allowed()) return;
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    const target = new URL(link.href, location.href);
    if (target.origin !== location.origin) return;
    const banner = link.matches('.bella-campaign');
    const article = link.closest('.archv-ezek-edit, .archv-jikoo-edit, .archv-layered-edit');
    const product = article && /\/products\/[^/]+\/?$/.test(target.pathname);
    if (!banner && !product) return;
    const root = banner ? link.parentElement : article;
    const candidates = Array.from(root.querySelectorAll(banner ? 'a.bella-campaign' : 'a[href*="/products/"]'));
    const feature = banner ? target.pathname.split('/').filter(Boolean).pop() : location.pathname.split('/').filter(Boolean).pop();
    const data = {
      feature_id: feature,
      link_path: target.pathname,
      source_path: location.pathname,
      link_position: candidates.indexOf(link) + 1,
      product_handle: product ? target.pathname.split('/').filter(Boolean).pop() : '',
      tracking_version: '20260905'
    };
    // Give the sandbox a bounded dispatch window before same-tab navigation.
    // Modified clicks/new tabs keep their native behavior.
    try {
      if (typeof window.Shopify?.analytics?.publish !== 'function') return;
      window.Shopify.analytics.publish(banner ? 'archv_banner_click' : 'archv_feature_product_click', data);
      if (!event.defaultPrevented && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && (!link.target || link.target === '_self') && !link.hasAttribute('download')) {
        event.preventDefault();
        window.setTimeout(() => location.assign(link.href), 200);
      }
    } catch (_) { /* Tracking must never affect shopping. */ }
  });
})();
